import type { RiskByIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetRiskByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetRiskByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetRiskByIdArgs = {
  riskId: string;
};

export const useLazyGetRiskById = createLazyQueryHook<
  UseLazyGetRiskByIdArgs,
  RiskByIdResponseRow[],
  GetRiskByIdQuery
>({
  trpcQuery: (client, { riskId }) =>
    client.frontend.risk.riskById.query({ riskId }),
  mapTrpcDataToGraphQL: (data) => ({ risk: data }),
  graphqlDocument: GetRiskByIdDocument,
  graphqlVariables: ({ riskId }) => ({ _eq: riskId }),
});
